<template>
    <div class="group cursor-pointer flex gap-4 rounded-2xl border border-app bg-card/70 backdrop-blur-2xl p-5 shadow-lg transition-all hover:-translate-y-1 hover:shadow-brand-500/10">
        <div
            class="h-16 w-16 shrink-0 rounded-2xl overflow-hidden border border-app bg-brand-500/10 flex items-center justify-center">
            <img v-if="speaker.photoUrl" :src="speaker.photoUrl" :alt="speaker.name" class="h-full w-full object-cover" />
            <span v-else class="text-brand-500 font-black text-lg">{{ initials(speaker.name) }}</span>
        </div>
        <div class="min-w-0">
            <h3 class="text-header font-bold leading-snug truncate group-hover:text-brand-500 transition-colors">
                {{ speaker.name }}
            </h3>
            <p v-if="speaker.role || speaker.company" class="text-body/80 text-xs font-semibold mt-0.5 truncate">
                {{ [speaker.role, speaker.company].filter(Boolean).join(' · ') }}
            </p>
            <p v-if="speaker.topic" class="text-body text-sm mt-2 line-clamp-2">“{{ speaker.topic }}”</p>
            <span
                class="inline-flex items-center gap-1 text-xs font-bold text-brand-500 mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                View profile
                <ArrowRight class="h-3.5 w-3.5" />
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ArrowRight } from 'lucide-vue-next';
import { EventSpeaker } from '~/types';
import { initials } from '../helpers';

defineProps<{ speaker: EventSpeaker }>();
</script>

<style scoped>
.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.border-app {
    border-color: rgb(var(--core-app-border));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}

.text-body {
    color: rgb(var(--core-body-text));
}
</style>
